import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { AuthGate, Admin } from 'auth';

const EvaluationView = React.lazy(() => import('./views/EvaluationView'));
const ListApplicationsView = React.lazy(() =>
  import('./views/ListApplicationsComponent')
);

function Routes() {
  return (
    <Switch>
      <Route
        exact
        path="/dashboard/aplicaciones"
        render={props => (
          <AuthGate
            allowed={[Admin]}
            canInvoke={[
              {
                url: '/api/internal/home_applications',
                method: 'get'
              },
              {
                url: '/api/internal/home_applications/:id/preview',
                method: 'get'
              }
            ]}
          >
            <ListApplicationsView {...props} />
          </AuthGate>
        )}
      />
      <Route
        exact
        path="/dashboard/aplicaciones/:id/:minimum_fico_score"
        render={props => (
          <AuthGate
            allowed={[Admin]}
            canInvoke={[
              {
                url: '/api/internal/home_applications/:id/preview',
                method: 'get'
              }
            ]}
          >
            <EvaluationView {...props} />
          </AuthGate>
        )}
      />
    </Switch>
  );
}

export default Routes;
